import { Component } from "react";
import { Button } from "./ui/button";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("UI error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen grid place-items-center bg-[#FAFAFA] p-6">
          <div className="text-center max-w-md">
            <h1 className="text-2xl font-bold font-outfit">Something went wrong</h1>
            <p className="text-zinc-500 mt-2 text-sm">An unexpected error occurred. Please reload the page.</p>
            <Button className="mt-6 bg-[#6366F1] hover:bg-[#4F46E5]" onClick={() => window.location.reload()}>
              Reload
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
